import type {VatCode} from "../../../../../generated/enums.ts";
import {VAT_CODE_RATE_LABELS} from "../../../../../types/vatCodes.ts";

export function vatCodeToBadgeLabel(vatCode: VatCode | null | undefined): string | null {
    if (!vatCode) {
        return null;
    }
    const rate = VAT_CODE_RATE_LABELS[vatCode];
    return rate ? `BTW ${rate}` : "BTW";
}
